import { render, staticRenderFns } from "./wordpress-alternate.vue?vue&type=template&id=7f95d106"
import script from "./wordpress-alternate.vue?vue&type=script&lang=js"
export * from "./wordpress-alternate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports